import type { Socket } from 'socket.io-client'

export default (event: string, data: Record<string, string | number | boolean | null>) => {
	if ('globalSocket' in window) {
		const socket = window.globalSocket as Socket
		socket?.emit(event, data)
	}
}
